export const LOCATION_SEARCH_DELAY_MS = 300;
export const LOCATION_SEARCH_MIN_LENGTH = 2;
export const LOCATION_SEARCHING_MESSAGE = "Finding locations...";
export const LOCATION_SINGLE_MAX_LENGTH = 240;
export const LOCATION_FIELDS = [
  { key: "city", label: "City", maxLength: 120 },
  { key: "state", label: "State", maxLength: 120 },
  { key: "country", label: "Country", maxLength: 80 },
] as const;
export const LOCATION_INPUT_CLASS_NAME =
  "h-11 w-full rounded-[10px] border border-black bg-white px-3 text-sm text-[#101828] outline-none focus:ring-2 focus:ring-[#F8D96B]";
